import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { BaseComponent, FormRequest } from '../../../modules/tcm-core.module';
import { Subscription } from 'rxjs/internal/Subscription';
import { BroadCastEvents } from '../../../common/broad-cast-events.enum';
import { ClaimInfoWidgetViewModel } from '../../../models/claims';
import { SecureBaseComponentContext } from '../../../modules/tcm-common/services/secure-base-component-context.service';
import { BaseComponent } from '../../tcm-core.module/components/base-component/base-component.component';
import { FormRequest } from '../../tcm-core.module/models/details/form-request';
import { TranslationService } from '../../../services';

@Component({
    selector: 'claim-info-widget',
    templateUrl: './claim-info-widget.component.html',
    styleUrls: ['./claim-info-widget.component.scss'],
    standalone: false
})
export class ClaimInfoWidgetComponent
  extends BaseComponent<FormRequest, ClaimInfoWidgetViewModel> {

  private updateSubscription: Subscription;
  private permissionsSubscription: Subscription;

  orderStatusTranslations: any;

  constructor(protected override componentContext: SecureBaseComponentContext, 
    protected override route: ActivatedRoute, 
    private translationService: TranslationService) {
    super(componentContext, route);

    this.actionName = 'Claims/InfoWidget';

    this.orderStatusTranslations = this.translationService.getOrderStatusTranslations();

    this.updateSubscription = this.componentContext.broadcastService
      .getEvents(BroadCastEvents.ClaimUpdated)
      .subscribe(e => {
        this.refresh();
      });
  }

  protected createRequestModel() {
    return {} as FormRequest;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.updateSubscription.unsubscribe();
  }
}
